export default [
	{ settings: true, isCheckbox: true, isCheckboxAll: true, isCheckboxTotal: true },
	{
		settings: true,
		text: "ID",
		value: "invoice_id",
		valueFilter: 'filter_id',
		func: true,
		sortable: true,
		model: { value: 'list' },
		dense: true,
		footer: "unique",
		totalMod: true,
		width: '120px',
	},
	{
		settings: true,
		text: "Status",
		value: "status",
		valueFilter: "filter_status",
		func: true,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Service",
		value: "service",
		valueFilter: "filter_service",
		func: true,
		sortable: true,
		model: { value: 'list' },
		nowrap: true
	},
	{
		settings: true,
		text: "Customer",
		value: "customer",
		valueFilter: "filter_customer",
		func: true,
		sortable: true,
		model: { value: 'list' },
		dense: true,
		modValue: "isCustomerLink"

	},
	{
		settings: true,
		text: "From",
		value: "from",
		valueFilter: "filter_from",
		func: true,
		sortable: true,
		model: { value: 'date' },
		dense: true,
		nowrap: true
	},
	{
		settings: true,
		text: "To",
		value: "to",
		valueFilter: "filter_to",
		func: true,
		sortable: true,
		model: { value: 'date' },
		dense: true,
		nowrap: true
	},
	{
		settings: true,
		text: "Generated by",
		value: "generated",
		valueFilter: "filter_generated",
		func: true,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Generated date",
		value: "generated_date",
		valueFilter: "filter_generated_date",
		func: true,
		sortable: true,
		model: { value: 'date' },
		dense: true
	},
	{
		settings: true,
		text: "Total check",
		value: "total_check",
		valueFilter: "filter_total_check",
		func: true,
		sortable: true,
		model: { value: 'number' },
		dense: true,
		dollar: true
	},
	{
		settings: true,
		text: "Paid",
		value: "pay_amount",
		valueFilter: "filter_pay_amount",
		func: true,
		sortable: true,
		model: { value: 'number' },
		dense: true,
		dollar: true,
		width: '100px',
	},
	{
		settings: true,
		text: "Not paid",
		value: "need_pay_amount",
		valueFilter: "filter_need_pay_amount",
		func: true,
		sortable: true,
		model: { value: 'number' },
		dense: true,
		dollar: true,
		width: '130px',
	},
	{
		settings: true,
		text: "Need to pay",
		value: "balance",
		valueFilter: "filter_balance",
		func: true,
		sortable: true,
		model: { value: 'number' },
		modValue: 'modBalance',
	},
	//
	// {
	// 	settings: true,
	// 	text: "Company expenses",
	// 	value: "expenses",
	// 	valueFilter: "filter_expenses",
	// 	func: true,
	// 	sortable: true,
	// 	model: { value: 'number' },
	// 	dense: true,
	// 	dollar: true
	// },
	{
		settings: true,
		text: "Mistake",
		value: "mistake",
		valueFilter: "filter_mistake",
		func: true,
		sortable: true,
		model: { value: 'number' },
		dense: true,
		dollar: true
	},

	{
		settings: true,
		text: "Loss",
		value: "loss",
		valueFilter: "filter_loss",
		func: true,
		sortable: true,
		model: { value: 'number' },
		dense: true,
		dollar: true
	},

	{
		settings: true,
		text: "Payment account",
		value: "payment_account",
		valueFilter: "filter_payment_account",
		func: true,
		sortable: true,
		model: { value: 'list' }
	},
	{
		text: "Actions",
		settings: true,
		buttons: [
			{
				perm: { or: [ 15 ] },
				value: 'send',
				text: 'Send',
				icon: { value: 'icon_send', w: 18, h: 18 },
				isCanDisabled: true,
			},
			// {
			// 	perm: { or: [ 13 ] },
			// 	value: 'file_report',
			// 	text: 'View',
			// 	icon: { value: 'icon_view', w: 20, h: 20 },
			// 	isCanDisabled: true,
			// },
			{
				perm: { or: [ 13 ] },
				value: 'file_report_mod',
				text: 'View',
				icon: { value: 'icon_view', w: 20, h: 20 },
				isCanDisabled: true,
			},
			{
				perm: { or: [ 13 ] },
				value: 'file_report_mod',
				text: 'Download',
				icon: { value: 'icon_download', w: 20, h: 20 },
				isCanDisabled: true,
			},
			// {
			// 	perm: true,
			// 	value: 'download',
			// 	text: 'Download',
			// 	icon: { value: 'icon_download', w: 18, h: 18 },
			// 	isCanDisabled: true,
			// },
		]
	},
	{
		settings: true,
		text: "Invoice status",
		value: "invoice_status",
		valueFilter: "filter_invoice_status",
		func: true,
		sortable: true,
		model: { value: 'list', },
		dense: true
	},
	{
		settings: true,
		text: "Pay",
		value: "pay",
		valueFilter: "filter_paid",
		func: true,
		sortable: true,
		model: { value: 'list', },
		dense: true,
		isPay: true,
		align: 'center'
	},
	{
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'delete',
				text: 'Delete',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'open',
				text: 'Open invoice',
				icon: { value: 'reset', w: 18, h: 18 },
			},
		],
	},
];
